import * as React from 'react';
import AppBar from '@mui/material/AppBar';
import Box from '@mui/material/Box';
import Toolbar from '@mui/material/Toolbar';
import IconButton from '@mui/material/IconButton';
import Typography from '@mui/material/Typography';
import Menu from '@mui/material/Menu';
import Container from '@mui/material/Container';
import Avatar from '@mui/material/Avatar';
import Tooltip from '@mui/material/Tooltip';
import MenuItem from '@mui/material/MenuItem';
import { Link } from 'react-router-dom';
import Client from './components/Client';
import BackOfficeConfig from './Config';
import MenuSmall from './components/MenuSmall';

import noImage from './images/noImage.png';
import kalopsia_logo from './images/kalopsia_logo.png';

import './css/TopBar.scss';

const settings = ['My Profile', 'Dashboard', 'Management Guide', 'User Manual', 'Logout'];

function resolveProfileImage(image) {
  if (!image) return noImage;
  if (/^(?:https?:|data:|blob:)/i.test(image)) return image;

  const baseUrl = BackOfficeConfig.BASE_API_URL || '';
  return `${baseUrl.replace(/\/$/, '')}/${String(image).replace(/^\//, '')}`;
}
//const ResponsiveAppBar = () => {
class ResponsiveAppBar extends React.Component {

  constructor(props) {
    super(props);

    this.state = {
      client: new Client ( "none" ),
      anchorEl: null,
      anchorReference: 'anchorEl',
      profile: {
        first_name: "",
        last_name: "",
        email: "",
        phone: "",
        type: null,
        person: {
          address: null,
          firstName: "",
          lastName: "",
          email: "",
          phone: "",
          image: noImage
        }
      },
      config: { }
    };


    this.setConfig = this.setConfig.bind(this);
    this.handleLogout = this.handleLogout.bind(this);
    this.handleProfile = this.handleProfile.bind(this);
    this.setProfileData = this.setProfileData.bind(this);
    this.handleTopClick = this.handleTopClick.bind(this);
    this.handleCloseUserMenu = this.handleCloseUserMenu.bind(this);
    this.handleOpenUserMenu = this.handleOpenUserMenu.bind(this);
    this.toggleSmallMenuOpen = this.toggleSmallMenuOpen.bind(this);

    this.profileMenu = React.createRef();
  }

  componentDidMount() {
    //window.addEventListener('load', this.handleLoad);

    this.setConfig ( );
    this.handleProfile ( );


    //this.setProfileData ( );
  }

  componentWillUnmount() { 
    //window.removeEventListener('load', this.handleLoad)  
  }

  setConfig ( ) {
    let configJson = localStorage.getItem ( "config" );
    let config = JSON.parse ( configJson );
    this.setState ( { config: config } );

    window.addEventListener('storageUpdate', () => {
      configJson = localStorage.getItem ( "config" );
      config = JSON.parse ( configJson );
      this.setState ( { config: config } );
    })
  }

  toggleSmallMenuOpen (state) {
    this.props.toggleSideBarCollapsed (state);

  }

  //const [anchorElNav, setAnchorElNav] = React.useState(null);
  //const [anchorElUser, setAnchorElUser] = React.useState(null);

  handleOpenNavMenu ( event ) {
    //setAnchorElNav(event.currentTarget);
  }

  handleOpenUserMenu ( event ) {
    //setAnchorElUser ( event.currentTarget );
    //console.log ( "Open menu !" );
    this.setState({ anchorEl: event.currentTarget });
  }

  handleCloseNavMenu ( ) {
    //setAnchorElNav(null);
  }

  handleCloseUserMenu ( ) {
    //console.log ( "handleCloseUserMenu:" + anchorElUser );
    //setAnchorElUser(null);
    this.setState({ anchorEl: null });
  }

  handleLogout = () => {
    this.state.client.logout ( );
    window.location.href = BackOfficeConfig.BASE_URL;
    /* localStorage.removeItem("apiUser");
    localStorage.removeItem("profile");
    window.location.href = BackOfficeConfig.BACKOFFICE_URL; */
  }

  handleTopClick ( event, value ) {
    //console.log ( "VALUE", event.target.innerText, value );
    switch ( value ) {
      case "Dashboard":
        window.location.href = BackOfficeConfig.BASE_URL;
        break;
      case "My Profile":
        if (this.props.setActiveContent) {
          this.props.setActiveContent("profile");
        }
        break;
      case "Logout":
        this.handleLogout ( );
        break;
      default:
        break;
    }
    this.handleCloseUserMenu();
  }

  setProfileData ( ) {
    try {
      const apiUser = JSON.parse(localStorage.getItem("apiUser") || "null");
      if (!apiUser?.profile) return;

      const storedProfile = apiUser.profile;
      const person = storedProfile.person || {};
      this.setState({
        profile: {
          ...storedProfile,
          person: {
            ...person,
            image: resolveProfileImage(person.image),
          },
        },
      });
    } catch (_error) {
      // Keep the safe empty profile when stored session data cannot be parsed.
    }
  }

  handleProfile ( ) {
    this.setProfileData ( );
    //e.preventDefault();
    /* const response = getProfile().then ((value) => {        
          localStorage.setItem('profile', "");
          let profileString = JSON.stringify ( value.profile );
          localStorage.setItem('profile', profileString );
          this.setProfileData ( );
        }); */
  }

  render() {
    const { anchorEl } = this.state;
    const open = Boolean(anchorEl);
    const profile = this.state.profile || {};
    const person = profile.person || {};
    const displayName = [profile.first_name, profile.last_name]
      .filter(Boolean)
      .join(' ')
      || [person.firstName, person.lastName].filter(Boolean).join(' ')
      || profile.username
      || 'User';
    const role = BackOfficeConfig.USER_TYPES?.[profile.user_type];

    let logo = kalopsia_logo;
    let name = "KALOPSIA";

    if ( this.state.config ) {
      let config = this.state.config;
      if ( config.identityImages ) {
        if ( config.identityImages.LOGO ) logo = config.identityImages.LOGO;
        let fileName = logo.replace(/\.[^/.]+$/, "");
        let fileExtension = logo.split(".").pop();
        logo = fileName + "_s." + fileExtension;
      }
      if ( config.identityTexts ) {
        if ( config.identityTexts.NAME ) name = config.identityTexts.NAME;
      }
    }

    return (
      <AppBar position="static" sx={{ bgcolor: "#1e2833" }}>
        <Container maxWidth="false">
          <Toolbar disableGutters variant="dense">
            {this.props.showSideBarToggle !== false && (
              <div className="smallMenu">
                <MenuSmall
                  toggleSmallMenu = {this.toggleSmallMenuOpen}
                />
                {/* <IconButton
                  size="large"
                  edge="start"
                  color="inherit"
                  aria-label="menu"
                  sx={{ mr: 2 }}
                >

                </IconButton> */}
              </div>
            )}


            <img src={logo} width="48px"></img>
            <Typography
              variant="h6"
              noWrap
              component="a"
              href={BackOfficeConfig.BASE_URL}
              sx={{
                mr: 2,
                display: { md: 'flex' },
                fontFamily: 'monospace',
                fontWeight: 700,
                fontSize: '1rem',
                letterSpacing: '.15rem',
                color: 'inherit',
                textDecoration: 'none',
                marginLeft: 1
              }}
            >
              {name}
            </Typography>

            <Box sx={{ flexGrow: 1, display: { xs: 'flex', md: 'none' } }}>            
            </Box>
            
            <Box sx={{ flexGrow: 1, display: { xs: 'none', md: 'flex' } }}>
            <Typography
              variant="h8"
              noWrap
              //component="a"
              //href="/"
              sx={{
                mr: 2,
                display: { xs: 'none', md: 'flex' },
                fontFamily: 'sans-serif',
                fontWeight: 500,
                letterSpacing: '.2rem',
                color: 'inherit',
                textDecoration: 'none',
                align: "right"
              }}
            >
              {displayName}{role ? ` (${role})` : ''}
            </Typography>
            </Box>         

            <Box sx={{ flexGrow: 0 }}>
              <Tooltip title="Open user menu">
                <IconButton
                  aria-label="Open user menu"
                  onClick={this.handleOpenUserMenu}
                  sx={{ p: 0 }}
                >
                  <Avatar alt={displayName} src={person.image || noImage} />
                </IconButton>
              </Tooltip>
              <Menu
                sx={{ mt: '45px' }}
                id="menu-appbar"
                ref={this.profileMenu}
                //anchorEl={anchorElUser}
                anchorEl={anchorEl}
                anchorOrigin={{
                  vertical: 'top',
                  horizontal: 'right',
                }}
                keepMounted
                transformOrigin={{
                  vertical: 'top',
                  horizontal: 'right',
                }}
                //open={Boolean(anchorElUser)}
                open={open}
                onClose={this.handleCloseUserMenu}
              >
                {settings.map((setting) => {
                  const guideLinkProps = setting === 'Management Guide'
                    ? {
                      component: Link,
                      to: '/management-guide',
                      target: '_blank',
                      rel: 'noopener noreferrer',
                    }
                    : {};
                  const manualLinkProps = setting === 'User Manual'
                    ? {
                      component: Link,
                      to: '/manual/',
                      target: '_blank',
                      rel: 'noopener noreferrer',
                    }
                    : {};
                  return (
                    <MenuItem
                      key={setting}
                      onClick={(e) => this.handleTopClick(e, setting)}
                      {...guideLinkProps}
                      {...manualLinkProps}
                    >
                      <Typography
                        textAlign="center"
                        className={setting === 'Management Guide' || setting === 'User Manual'
                          ? 'topbar-new-tab-label'
                          : undefined}
                      >
                        {setting}
                      </Typography>
                    </MenuItem>
                  );
                })}
              </Menu>
            </Box>
          </Toolbar>
        </Container>
      </AppBar>
    );
}
}
export default ResponsiveAppBar;
